module.exports = __webpack_public_path__ + "img/DW365-336.44ce93ad.jpg";